import { render, staticRenderFns } from "./CreateEventActivityTypeModal.vue?vue&type=template&id=fc889572&scoped=true"
import script from "./CreateEventActivityTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateEventActivityTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEventActivityTypeModal.vue?vue&type=style&index=0&id=fc889572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc889572",
  null
  
)

export default component.exports